import { Attachment } from '../types/shared';

export const base64ToBlob = (base64: string, mimeType: string): Blob => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
};

export const fileToBase64 = async (
    file: File
): Promise<Attachment | undefined> => {
    if (!file) return;
    const reader = new FileReader();
    return await new Promise((res) => {
        reader.onload = (event) => {
            const match = file.name.match(/\.(\w+)$/);
            res({
                name: file.name,
                base64: event?.target?.result?.toString(),
                extension: match ? match[0] : '',
            });
        };

        reader.readAsDataURL(file);
    });
};

export function downloadFile(url: string, filename: string) {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export interface GeneratedFile {
    name: string;
    url: string;
    mimeType: string;
}
